/*
 * EverQuilts - product page redesign (01.11.2026)
 * Loaded by snippets/eq-pdp-top.liquid. Styles: assets/eq-pdp-redesign.css.
 *
 * 1. "Shop Bundle" buttons (snippets/eq-bundle-save.liquid, data-eq-bundle-qty)
 *    open the existing bundle builder (snippets/eq-bundle-builder.liquid +
 *    assets/eq-bundle-builder.js) in a pop-up (bottom sheet on phones) with
 *    the card's number of items; the shirt being viewed is item 1.
 *    The builder is moved out of the buy buttons into the pop-up once it has
 *    started (it keeps its link to the product form), so it no longer shows
 *    inline. If the shopper has not picked a size yet, the button first
 *    asks for the size (same nudge as Add to cart) and does not open.
 *    No builder on the page (or JS error) -> the button stays a normal link
 *    to the card's collection.
 * 2. "Save For Later" moves under the Bundle & Save cards (same product-info,
 *    so the wishlist script still finds the selected variant).
 *
 * Only the main product section (product-info#MainProduct-*) is touched.
 */
(function () {
  'use strict';
  if (window.eqPdpRedesign) return;
  window.eqPdpRedesign = true;

  var modal = null;

  function mainInfo(el) {
    return el && el.closest ? el.closest('product-info[id^="MainProduct-"]') : null;
  }

  function topChild(container, el) {
    var node = el;
    while (node && node.parentElement && node.parentElement !== container) node = node.parentElement;
    return node && node.parentElement === container ? node : null;
  }

  /* ------------------------------------------------------------ Save For Later */

  function moveSaveLater(info) {
    var container = info.querySelector('.product__info-container');
    var save = info.querySelector('.eq-save-later');
    var cards = info.querySelector('.eqbs--v2');
    if (!container || !save || !cards || save.__eqMoved) return;
    var anchor = topChild(container, cards);
    if (!anchor) return;
    anchor.parentNode.insertBefore(save, anchor.nextSibling);
    save.__eqMoved = true;
  }

  /* ------------------------------------------------------------ pop-up */

  function buildModal() {
    if (modal) return modal;
    var el = document.createElement('div');
    el.className = 'eq-bbm';
    el.hidden = true;
    el.innerHTML =
      '<div class="eq-bbm__overlay" data-eq-bbm-close></div>' +
      '<div class="eq-bbm__panel" role="dialog" aria-modal="true" aria-labelledby="EqBbmTitle">' +
      '<div class="eq-bbm__head">' +
      '<p class="eq-bbm__title" id="EqBbmTitle">Build your bundle</p>' +
      '<button type="button" class="eq-bbm__close" data-eq-bbm-close aria-label="Close">' +
      '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="eq-bbm__body"></div>' +
      '</div>';
    document.body.appendChild(el);
    modal = { el: el, body: el.querySelector('.eq-bbm__body'), title: el.querySelector('.eq-bbm__title'), last: null };

    /* Capture phase: runs before the builder's own handlers. */
    el.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('[data-eq-bbm-close]')) {
          e.preventDefault();
          closeModal();
          return;
        }
        /* "Choose your size above": close first, the builder then scrolls to Size. */
        if (e.target.closest('[data-eq-bb-size]')) closeModal(true);
      },
      true
    );
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !modal || modal.el.hidden) return;
      var sheet = document.querySelector('.eq-bb-sheet');
      if (sheet && !sheet.hidden) return; /* the design picker closes first */
      closeModal();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'eq-bundle-builder') closeModal(true);
      });
    }
    return modal;
  }

  function openModal(builder, qty, label, opener) {
    buildModal();
    if (builder.parentNode !== modal.body) {
      modal.body.innerHTML = '';
      modal.body.appendChild(builder);
    }
    if (typeof builder.eqBbSetSize === 'function') builder.eqBbSetSize(qty);
    modal.title.textContent = label || 'Build your bundle';
    modal.last = opener || document.activeElement;
    modal.el.hidden = false;
    document.documentElement.classList.add('eq-bbm-lock');
    modal.body.scrollTop = 0;
    requestAnimationFrame(function () {
      modal.el.classList.add('is-open');
    });
    var close = modal.el.querySelector('.eq-bbm__close');
    try {
      close.focus({ preventScroll: true });
    } catch (e) {
      close.focus();
    }
  }

  function closeModal(keepFocus) {
    if (!modal || modal.el.hidden) return;
    modal.el.classList.remove('is-open');
    modal.el.hidden = true;
    document.documentElement.classList.remove('eq-bbm-lock');
    var last = modal.last;
    modal.last = null;
    if (!keepFocus && last && last.isConnected) {
      try {
        last.focus({ preventScroll: true });
      } catch (e) {
        last.focus();
      }
    }
  }

  /* The builder of this product page: still inline, or already in the pop-up. */
  function builderFor(info) {
    var el = info.querySelector('[data-eq-bb]');
    if (el) return el;
    var all = document.querySelectorAll('.eq-bbm [data-eq-bb]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].__eqBb && all[i].__eqBb.info === info) return all[i];
    }
    return null;
  }

  function sizeUnset(info) {
    var ctx = info.__eqCro;
    return !!(ctx && ctx.useSize && !ctx.chosen);
  }

  function onShopBundle(e) {
    var btn = e.target.closest && e.target.closest('[data-eq-bundle-qty]');
    if (!btn) return;
    var info = mainInfo(btn);
    if (!info) return;
    var builder = builderFor(info);
    /* Builder missing or not started (e.g. its script failed): keep the link. */
    if (!builder || !builder.__eqBb || builder.hidden) return;
    e.preventDefault();
    if (sizeUnset(info)) {
      /* eq-cro-pdp.js stops this submit, scrolls to Size and says "Please choose your size." */
      var section = info.dataset.section;
      var atc = section && document.getElementById('ProductSubmitButton-' + section);
      if (atc) atc.click();
      return;
    }
    var qty = Number(btn.getAttribute('data-eq-bundle-qty')) || 3;
    var card = btn.closest('.eqbs__card');
    var name = card && card.querySelector('.eqbs__name');
    openModal(builder, qty, name ? name.textContent.trim() : '', btn);
  }

  /* ------------------------------------------------------------ wiring */

  function init() {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(function (info) {
      moveSaveLater(info);
    });
  }

  document.addEventListener('click', onShopBundle);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
